import {
  AgoraRTCProvider,
  useRTCClient
} from "agora-rtc-react";
import AgoraRTC from "agora-rtc-sdk-ng";
import AuthenticationWorkflowManager from "./authenticationWorkflowManager.jsx";
import config from "./config";
import { Box, IconButton, Modal } from "@mui/material";
import Draggable from "react-draggable";
import { useState } from "react";
// import { PanelTopCloseIcon } from "lucide-react";
export default function AuthenticationWorkflow(props) {
console.log("AuthenticationWorkflow props: ", props);

  const agoraEngine = useRTCClient(AgoraRTC.createClient({ codec: "vp8", mode: config.selectedProduct }));

  return (
    <div>
      
              <AgoraRTCProvider client={agoraEngine}>
                <AuthenticationWorkflowManager client={agoraEngine} {...props} />
              </AgoraRTCProvider>
            
      </div>
  );
}
